import React, { Component } from 'react'
import axios from 'axios'
import Velocity from 'velocity-animate'

import rApp from './rapp'
import { util } from './util'
import Litem from './litem'
import { CloseIcon } from './icons'

// Minicart Modal
class Minicart extends Component {
  constructor(props) {
    super(props)
    this.shopCartSettings = shopCartSettings
    rApp.MinicartComponent = this
    this.defaultCartMessage = this.shopCartSettings.defaultMessage ? this.shopCartSettings.defaultMessage : null

    this.state = {
      isCartOpen: false,
      giftMsgIsVisibile: false,
      giftMsgText: '',
      responseGiftMsg: '',
      litems: [],
      isLoadingFetchCart: false,
      cartCount: 0,
      cartTotal: 0,
      defaultVariantRecos: this.shopCartSettings.productAddons,
      hasBackrorderedItem: false,
      hasEmbroideredItem: false,
      cartMessage: this.defaultCartMessage,
      variantRecos: null,
      currentEmbProperties: null,
      isAddEventCustom: false
    }

    this.minicartScrimRef = React.createRef()
    this.minicartModalRef = React.createRef()
    this.minicartAddonsRef = React.createRef()
    this.toggleCart = this.toggleCart.bind(this)

    const minicartToggle = document.getElementById('minicart-toggle')
    minicartToggle.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      this.toggleCart()
    })

    this.minicartCountEl = document.getElementById('minicart-toggle__count')

    this.getCartData()
    window.addVariantToCart = this.addVariant.bind(this);
  }

  checkIfCartPage() {
    if (window.location.pathname === '/cart') this.toggleCart()
  }

  updateCartNote() {
    axios.post('/cart/update.js', { note: this.state.giftMsgText })
    .then(response => {
      this.setState({
        giftMsgText: response.data.note ? response.data.note : '',
        responseGiftMsg: response.data.note ? response.data.note : ''
      })
    })
  }

  getCartData(openModal = false) {
    this.setState({isLoadingFetchCart: true})
    axios.get('/cart.js')
    .then(response => {
      this.setState({
        litems: [...response.data.items],
        itemCount: response.data.item_count,
        cartCount: response.data.items.length,
        cartTotal: response.data.items_subtotal_price,
        giftMsgText: response.data.note ? response.data.note : '',
        responseGiftMsg: response.data.note ? response.data.note : ''
      })

      // update icon count in header
      if (response.data.item_count > 0) {
        this.minicartCountEl.classList.add('minicart-toggle__count--visible')
      } else {
        this.minicartCountEl.classList.remove('minicart-toggle__count--visible')
      }
      this.minicartCountEl.innerHTML = response.data.item_count

      this.setState({isLoadingFetchCart: false})

      if (this.state.cartCount === 0 && this.state.isCartOpen) this.toggleCart()
      if (openModal && !this.state.isCartOpen) this.toggleCart()
      this.setCartMessage()
    })
    .catch(error => console.log(error))
  }

  setCartMessage() {
    if (this.state.litems.some(e => e.properties && e.properties['Status'])) {
      this.setState({
        hasBackrorderedItem: true,
        cartMessage: this.shopCartSettings.backorderMessage
      })
    } else if (this.state.litems.some(e => e.properties && e.properties['Embroidery Text'])) {
      this.setState({
        hasEmbroideredItem: true,
        cartMessage: this.shopCartSettings.embroideryMessage
      })
    } else {
      this.setState({
        hasBackrorderedItem: false,
        hasEmbroideredItem: false,
        cartMessage: this.defaultCartMessage
      })
    }
  }

  addVariant(id = null, quantity = 1, embProperties = null) {
    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      }
    }
    let data = { quantity, id }
    if (embProperties !== null) data.properties = embProperties

    if (id !== null) {
      axios.post('/cart/add.js', data, config)
        .then(() => {
          this.getCartData(true)
        })
        .catch(error => {
          if (error.response) {
            alert(error.response.data.description)
          }
        })
    }
  }

  toggleCart() {
    let scrimOpacity = this.state.isCartOpen ? [0, 0.8] : [0.8, 0]
    let addonOpacity = this.state.isCartOpen ? [0, 1] : [1, 0]
    let translateX = this.state.isCartOpen ? ['100%', 0] : [0, '100%']
    let modalDisplay = this.state.isCartOpen ? 'none' : 'flex'
    let display = this.state.isCartOpen ? 'none' : 'block'

    // slide in modal
    Velocity(this.minicartModalRef.current,
      { translateX },
      {
        duration: 200,
        easing: [0.215, 0.61, 0.355, 1],
        display: modalDisplay,
        begin: () => {
          if (this.state.isCartOpen) {
            document.body.classList.remove('no-scroll')
          } else {
            document.body.classList.add('no-scroll')
          }

          // scrim
          Velocity(this.minicartScrimRef.current,
            { opacity: scrimOpacity },
            {
              duration: 200,
              easing: [0.215, 0.61, 0.355, 1],
              display,
              complete: () => {
                this.setState({ isCartOpen: !this.state.isCartOpen })
              }
            })

          // addons
          if (this.minicartAddonsRef.current !== null) {
            Velocity(this.minicartAddonsRef.current,
              { opacity: addonOpacity},
              {
                duration: 200,
                easing: [0.215, 0.61, 0.355, 1],
                display: modalDisplay,
              })
          }
        }
      })

    if (!this.state.isCartOpen) {
      var dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'view_cart',
        ecommerce: {
          currency: 'USD',
          value: parseInt(util.formatMoney(this.state.cartTotal).replace('$', '').replace(',', '').replace(/'/g, '')),
          items: this.state.litems.map((litem, i) => ({
            item_list_id: `${litem.product_id}`,
            item_list_name: null,
            item_id: `${litem.variant_id}`,
            item_name: `${litem.product_title}`,
            affiliation: 'Weezie Towels',
            currency: 'USD',
            coupon: null,
            // discount: parseInt(util.formatMoney(litem?.total_discount.replace('$', '').replace(',', ''))),
            index: i,
            item_brand: 'Weezie Towels',
            item_category: `${litem.product_type}`,
            item_category2: `${litem.options_with_values[0].value}`,
            item_category3: null,
            item_category4: null,
            item_variant: `${litem.options_with_values[1].value}`,
            price: parseInt(util.formatMoney(litem.price).replace('$', '').replace(',', '')),
            quantity: litem.quantity
          }))
        }
      })
    }
  }

  onCheckoutInit() {
    var dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: 'view_cart',
      ecommerce: {
        currency: 'USD',
        value: parseInt(util.formatMoney(this.state.cartTotal).replace('$', '').replace(',', '').replace(/'/g, '')),
        items: [this.state.litems.map((litem, i) => ({
          item_list_id: `${litem.product_id}`,
          item_list_name: `${litem.product_title}`,
          item_id: `${litem.variant_id}`,
          item_name: `${litem.product_title}`,
          affiliation: 'Weezie Towels',
          currency: 'USD',
          coupon: null,
          // discount: parseInt(util.formatMoney(litem?.total_discount.replace('$', '').replace(',', ''))),
          index: i,
          item_brand: 'Weezie Towels',
          item_category: `${litem.product_type}`,
          item_category2: `${litem.options_with_values[0].value}`,
          item_category3: null,
          item_category4: null,
          item_variant: null,
          price: parseInt(util.formatMoney(litem.price).replace('$', '').replace(',', '')),
          quantity: litem.quantity
        }))]
      }
    })
  }

  componentDidMount() {
    this.checkIfCartPage()
  }

  componentDidUpdate() {
    this.addEventButtonRecommendations()
  }

  addEventButtonRecommendations () {
    if (this.state.isCartOpen && this.state.isAddEventCustom == false) {
      const addButtons = document.getElementsByClassName('litem--mini');
  
      if (addButtons.length > 0) {
        const litemHeader = addButtons[0].querySelector('.litem__header');
        
        if (litemHeader) {
          const linkElement = litemHeader.querySelector('a');
          
          if (linkElement && linkElement.textContent.toLowerCase() === 'gift wrap') {
            const variantId = 30326974185557;
            
            addButtons[0].addEventListener('click', () => this.addVariant(variantId, 1, {}));
            this.setState({ isAddEventCustom: true })
          }
        }
      }
    }
  }

  render() {
    const scriptContent = `
      options = {
        realtime: true,
      };
    `;

    let price = this.state.cartTotal / 100;
    const goal = 225;
    let percentage = Math.min((price / goal) * 100, 100);
    const computedWidth = this.state.isCartOpen ? `${percentage}%` : '0%';
    const amountNeeded = goal - price;

    axios.get('/cart.js')
      .then(response => {
        const cart = response.data;

        cart.items.forEach(item => {
          if (item.handle === 'gift-wrap' && item.quantity > 1) {
            console.warn('Warning: More than one gift-wrap item in the cart.');
            const updates = {
              30326974185557: 1,
            };
        
            axios.post(
              `/cart/update.js`,
              { updates },
              {
                headers: {
                  'Content-Type': 'application/json',
                },
              }
            )
              .then((response) => {
                const data = response.data;
                console.log('Cart updated:');
              })
              .catch((error) => {
                console.error('Error updating cart:', error);
              });
          }
        });
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });

    return (
      <>
        <div className="minicart">
          {window.location.pathname === '/cart' ?
            <a className="minicart__scrim" href="/" ref={this.minicartScrimRef} />
          :
            <div className="minicart__scrim" ref={this.minicartScrimRef} onClick={() => this.toggleCart()} />
          }

          <div className="minicart__modal" ref={this.minicartModalRef}>
            {window.location.pathname === '/cart' ?
              <a className={`minicart__close` + `${this.shopCartSettings.discountMessage ? ' has-message' : ''}`} href="/">
                <CloseIcon />
              </a>
            :
              <button className={`minicart__close` + `${this.shopCartSettings.discountMessage ? ' has-message' : ''}`} onClick={() => this.toggleCart()} aria-label="Cart close">
                <CloseIcon />
              </button>
            }

            {this.shopCartSettings.discountMessage &&
              <div className="minicart__discount-message type type--small">
                {this.shopCartSettings.discountMessage}
              </div>
            }
            
            <div className='main-container-progress-bar'>
            <p className='heading-progress-bar'>Fast and Free shipping over $225</p>
            <div className="progress-bar-container">
            <div
              className="progress-bar-fill"
              style={{ width: computedWidth }}
            >
              </div>
            </div>
            {amountNeeded > 0 ? (
              <p className="x-price-away-from-shipping">
                You’re ${amountNeeded} away from <span style={{color: "#FF947D"}}>FREE SHIPPING!</span>
              </p>
            ) : (
              <p className="free-shipping-message">
                Congratulations! You got <span style={{color: "#FF947D"}}>FREE SHIPPING!</span>
              </p>
            )}
            </div>

            <span className="minicart__title">Your Cart</span>
            {/* <p className="minicart__shipping">
              {((this.state.cartTotal / 100) < (this.shopCartSettings.shippingThreshold)) ?
                `You’re ${util.formatMoney((this.shopCartSettings.shippingThreshold * 100) - this.state.cartTotal)} away from ` :
                `You’ve qualified for `}
              <span>Free Shipping!</span>
            </p> */}

            <div className="minicart__inner">
              <div className="minicart__lineitems">
                { this.state.isLoadingFetchCart ? <p>loading ..</p> : (
                  this.state.litems.map((litem, i) => (
                    <Litem
                      hasGiftMessage={this.state.giftMsgText !== ''}
                      showGiftMessage={() => this.setState({ giftMsgIsVisibile: true })}
                      setCurrentEmbProperties={(properties) => this.setState({ currentEmbProperties: properties })}
                      setVariantRecos={(varRecos) => this.setState({ variantRecos: varRecos ? [...varRecos] : null })}
                      MinicartClass={this}
                      index={i + 1}
                      key={`${litem.id}-${i}`}
                      {...litem} 
                    />
                  ))
                )}

                {(this.state.cartMessage !== null && this.state.cartCount > 0) && <div className="minicart__message">
                  <p className="type type--small">{ this.state.cartMessage }</p>
                </div>}
                {/* <div class="weezie-guarantee-wrapper">     
                    <div class="weezie-guarantee">
                        <h3>Our Promise</h3>
                        <p><span>Wowed, or we'll make it right.</span>If for any reason you’re not 100% wowed by Weezie, <a href="mailto:holler@weezietowels.com">holler</a> and we’ll make it right.</p>
                    </div>
                </div> */}
              </div>

              <div className={`minicart__addons minicart__addons--cartopen-${this.state.isCartOpen}`} ref={this.minicartAddonsRef}>
                <div dangerouslySetInnerHTML={{ __html: `<script type="searchspring/personalized-recommendations" profile="view-cart">${scriptContent}</script>` }} />

                {/* 
                  <span className="minicart__addons-title">{this.state.cartCount > 0 ? 'Complete your set' : 'Your cart is empty, lets fix that!'}</span>
                  {(this.state.variantRecos !== null && this.state.cartCount === 1) 
                  ?
                    this.state.variantRecos.map((variant, i) => (
                      <RecoCard
                        key={i}
                        embProperties={this.state.currentEmbProperties}
                        litems={this.state.litems}
                        addToCart={(variantId, properties) => this.addVariant(variantId, 1, properties)}
                        variant={variant} 
                      />
                    )) 
                  :
                    this.state.defaultVariantRecos.map((variant, i) => (
                      <RecoCard
                        key={i}
                        litems={this.state.litems}
                        addToCart={(variantId) => this.addVariant(variantId, 1)}
                        variant={variant} 
                      />
                    ))
                  }
                */}
              </div>
            </div>
            
            {this.state.litems[0] !== undefined &&
              <>
                {!(this.state.litems.length === 1 && this.state.litems[0].product_title === 'Gift Wrap') &&
                  <div className={`minicart__footer minicart__footer--isvisible-${this.state.cartCount > 0}`}>
                    <div className="minicart__giftmsg">
                      <div className={`minicart__giftmsg-toggle minicart__giftmsg-toggle--active-${this.state.giftMsgIsVisibile}`} tabIndex="0" onKeyPress={(event) => { if (event.charCode == 13) {this.setState({ giftMsgIsVisibile: !this.state.giftMsgIsVisibile })}}} onClick={() => this.setState({ giftMsgIsVisibile: !this.state.giftMsgIsVisibile })}>
                        <p className={`minicart__giftmsg-toggle-text minicart__giftmsg-toggle-text--active-${this.state.giftMsgText.length > 0}`}>
                          Add a Gift Message
                          {(this.state.giftMsgText.length > 0 && !this.state.giftMsgIsVisibile) && <span>Edit note</span>}
                        </p>
                        {this.state.giftMsgIsVisibile && <div className="minicart__giftmsg-arrow"></div>}
                      </div>

                      {this.state.giftMsgIsVisibile && (
                        <div className={`minicart__giftmsg-content minicart__giftmsg-content--active-${this.state.giftMsgIsVisibile}`}>
                          <span className="minicart__giftmsg-label">Prices will be excluded. Please note all items will ship together.</span>

                          <div className="minicart__giftmsg-textarea-wrap">
                            <label className="minicart__giftmsg-label" htmlFor="minicart__giftmsg-textarea">Your Message</label>
                            <textarea
                              className="minicart__giftmsg-textarea"
                              id="minicart__giftmsg-textarea"
                              value={this.state.giftMsgText}
                              maxLength="200"
                              onChange={(e) => this.setState({ giftMsgText: e.target.value })}></textarea>
                            <span className="minicart__giftmsg-label minicart__giftmsg-label--count">{this.state.giftMsgText.length}/200</span>
                          </div>

                          {(this.state.responseGiftMsg !== this.state.giftMsgText) && (
                            <span
                              role="button"
                              className="minicart__giftmsg-btn btn btn--navy"
                              tabIndex="0"
                              onKeyPress={(event) => { if (event.charCode == 13) {this.updateCartNote()}}}
                              onClick={() => this.updateCartNote()}>Save message</span>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="minicart__subtotal-wrap">
                      <p className="minicart__subtotal">Subtotal <span>{util.formatMoney(this.state.cartTotal, '${{amount}}').replace('.00', '')}</span></p>
                      <a href="/checkout" className={`minicart__btn btn btn--full btn--navy ${(this.state.cartCount < 1) ? 'btn--disabled' : '' }`} onClick={() => this.onCheckoutInit()}>Checkout</a>
                      <span className="minicart__label">Final Tax and Shipping calculated at checkout</span>
                    </div>
                  </div>
                }
              </>
            }
          </div>
        </div>
      </>
    )
  }
}

export default Minicart
